<mat-card class="translation-card">

  <div class="header">
    <h2>{{ literalKey }}</h2>
  </div>

  <div class="translations-container" [formGroup]="form">

    <div class="translation-block" *ngFor="let lang of languages">

      <div class="lang-header">
        <strong>{{ lang }}</strong>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput rows="4" [formControlName]="lang">
        </textarea>
      </mat-form-field>

    </div>
  </div>
</mat-card>